import { DialogAction, PreparedDialogs } from './types';
import AboutNeolexon from '../../../SharedComponents/AboutNeolexon/AboutNeolexon';
import { Kontakt } from '../../../SharedComponents/CustomDropdown/Kontakt';
import { MyAccount } from '../../../SharedComponents/CustomDropdown/MyAccount';
import { AccountDelete } from '../../../SharedComponents/AccountDelete';
import { StarsDialog } from '../../../StarsDialog';
import { NoPermission } from '../../../NoPermission';
import { SelectHealthInsurance } from '@/screens/LicenseBooking/SelectHealthInsurance';

export const PREPARED_DIALOGS: PreparedDialogs = {
  logoutDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Abmelden',
    content: 'Möchten Sie sich wirklich abmelden?',
    danger: true,
    confirmAction: {
      label: 'Abmelden',
      onPress,
    },
  }),
  aboutNeolexonDialog: () => ({
    title: 'Über neolexon Aphasie',
    contentComponent: () => <AboutNeolexon />,
    cancelable: false,
    cancelOnBackdropPress: true,
  }),
  kontaktDialog: () => ({
    title: 'Kontakt',
    contentComponent: () => <Kontakt />,
    cancelable: false,
    cancelOnBackdropPress: true,
  }),
  myAccountDialog: () => ({
    title: 'Mein Benutzerkonto',
    contentComponent: () => <MyAccount />,
    cancelable: false,
    cancelOnBackdropPress: true,
  }),
  accountDeleteDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Alle Daten unwiderruflich löschen',
    contentComponent: () => <AccountDelete />,
    confirmAction: {
      label: 'unwiderruflich löschen',
      onPress,
    },
    danger: true,
  }),
  selectHealthInsuranceDialog: (onStop) => ({
    title: 'Lizenz buchen',
    contentComponent: () => <SelectHealthInsurance />,
    cancelable: false,
    confirmAction: {
      label: 'Abbrechen',
      onPress: onStop,
    },
  }),
  starsProgressDialog: ({
    minutesExercised,
    stars,
    patient,
    onConfirm,
    onStop,
  }) => {
    return {
      title: `Toll! Heute schon ${minutesExercised} Minuten geübt!`,
      contentComponent: () => <StarsDialog stars={stars} patient={patient} />,
      confirmAction: {
        label: 'Weiter',
        onPress: onConfirm,
      },
      cancelAction: {
        label: 'Stop',
        onPress: onStop,
      },
      cancelOnBackdropPress: false,
    };
  },
  noPermissionDialog: () => {
    return {
      title: 'Zugang abgelaufen',
      contentComponent: () => <NoPermission />,
      cancelable: false,
      danger: true,
    };
  },
  noInternetDialog: () => ({
    title: 'Keine Verbindung',
    content:
      'Keine Verbindung zum neolexon Server. Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
    danger: true,
    cancelable: false,
  }),
};
